import { api } from '../hooks/useConfigureAxios';


export const SettingsAPI = {
  getBargeInformation: async function () {
    const response = await api.request({
      url: `/configuration/barge`,
      method: 'GET',
    });
    return response.data;
  },

  getStaticFilesInformation: async function () {
    const response = await api.request({
      url: `configuration/staticfilessource`,
      method: 'GET',
    });
    return response.data;
  },

  getEdgeCredentials: async function () {
    const response = await api.request({
      url: `configuration/edgecredentials`,
      method: 'GET',
    });
    return response.data.Credentials;
  },
};
